import React from 'react';

import { getFileExtension, isPdfFile } from '@whelk/utils/src/file';
import { Pdf } from './Pdf';

// import { getFileSvg } from '../../Base/FileCard/FileIcon';

export interface FilePreviewProps {
  filePreviewUrl: string;
  fileName: string;
}

export function FilePreview({ filePreviewUrl, fileName }: FilePreviewProps) {
  const suffix = getFileExtension(fileName);
  let FileNode = <div>暂不支持此类型</div>;

  if (isPdfFile(suffix)) {
    // 只有审核通过的pdf可以预览
    FileNode = <Pdf url={filePreviewUrl} />;
  }
  return FileNode;
}
